import React, { useMemo } from "react"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { useApiQuery } from "../../../../../../../core/api/useApiQuery"
import { useMerchant } from "../../../../../../merchants/merchantHooks"
import { FormikMultipleAutoComplete } from "../../../../../../../shared/components/forms/Formik"
import { ShopsQuery, fetchShopsList } from "../../../../shops/shopsApi"

export function SelectShop() {
    const { merchantId } = useMerchant()

    const shops = useApiQuery(fetchShopsList, {
        queryName: ShopsQuery.LIST,
        dependencies: {
            merchantId,
        },
        select: (data) => data.shops,
    })

    const data = useMemo(() => shops.data ?? [], [shops.data])

    return (
        <LocalizedStrict id="create-or-edit-price-list-field-shops" attrs={{ label: true }}>
            <FormikMultipleAutoComplete
                name="shops"
                label="Shops"
                options={data}
                isOptionEqualToValue={(option, value) => option.id === value}
                areOptionsEqual={(x, y) => x.id === y.id}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
            />
        </LocalizedStrict>
    )
}
